import { observer } from 'mobx-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Typography,
} from '@mui/material';
import { useEventsStore } from '../../../Stores/EventsStore';
import EditEventForm from '../EditEventForm/EditEventForm';
import Topbar from '../../../Components/Topbar/Topbar';
import { error, success } from '../../../Common/Toast/Toast';

const EventViewEdit = () => {
  const eventsStore = useEventsStore();
  const [event, setEvent] = useState(null);
  const { id } = useParams();
  const [isEditMode, setIsEditMode] = useState(false);
  const navigate = useNavigate();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [update, setUpdate] = useState(true);

  useEffect(() => {
    if (id && update) {
      eventsStore
        .getEventById(id)
        .then((response) => {
          setEvent(response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setUpdate(false);
        });
    }
  }, [id, update]);

  const onDelete = () => {
    setDeleteModalOpen(true);
  };

  const deleteEvent = () => {
    eventsStore
      .deleteEvent(id)
      .then(() => {
        success('Η εκδήλωση διαγράφηκε');
        navigate('/events');
      })
      .catch((err) => {
        error('Κάτι πήγε στραβά');
        console.error(err);
      });
  };

  return (
    <Box className="min-h-[110vh]">
      <Topbar title="Ηλεκτρονικές Υπηρεσίες" />
      <Typography
        className="pt-6 pb-5 pl-4"
        variant="h3"
        color={'#003375'}
        gutterBottom
      >
        <span
          className="cursor-pointer hover:underline"
          onClick={() => navigate('/events')}
          style={{ color: '#003375' }}
        >
          Οι εκδηλώσεις μου
        </span>
        <span style={{ color: '#003375' }}> / Προβολή - Επεξεργασία</span>
      </Typography>
      {event ? (
        <Box className="flex flex-col w-full justify-right items-end pt-6 pb-5 pl-4 pr-4">
          <EditEventForm
            isEditMode={isEditMode}
            setIsEditMode={setIsEditMode}
            event={event}
            onDelete={onDelete}
            setParentUpdate={setUpdate}
          />
        </Box>
      ) : (
        <div className="text-center py-10">
          <CircularProgress
            sx={{
              color: '#003375',
            }}
            size="3rem"
          />
        </div>
      )}

      <Modal
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Είστε σίγουροι;
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Η εκδήλωση θα διαγραφεί οριστικά.
          </Typography>
          <Box className="flex justify-end gap-4 mt-4" sx={{ mt: 2 }}>
            <Button
              variant="contained"
              onClick={deleteEvent}
              sx={{
                backgroundColor: '#f44336',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#f44336',
                  color: 'white',
                  opacity: 0.9,
                },
                textTransform: 'none',
              }}
            >
              Ναι
            </Button>
            <Button
              variant="contained"
              onClick={() => setDeleteModalOpen(false)}
              sx={{
                backgroundColor: '#003375',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#003375',
                  color: 'white',
                  opacity: 0.9,
                },
                textTransform: 'none',
              }}
            >
              Όχι
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default observer(EventViewEdit);
